<template>
  <div id="app">
    <Header/>
    <main class="main-content">
      <router-view />
    </main>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: { Header, Footer },
  mounted() {
    // 保留路由跳转回顶部的逻辑（不受Footer布局影响）
    this.$router.afterEach(() => {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'instant'
        });
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        console.log('已执行滚动到顶部，当前滚动位置：', window.scrollY);
      }, 100);
    });
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  font-weight: 500;
  color: #2c3e50;
  /* 核心：用min-height+flex实现Footer自适应底部 */
  min-height: 100vh; 
  display: flex;
  flex-direction: column;
  /* 只保留Header的padding（因为Header还是fixed） */
  padding-top: 60px;
  /* 删掉Footer的padding-bottom（不再固定，无需留位置） */
}

/* Header 仍固定顶部（保持原有逻辑） */
Header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  background: #fff;
  height: 60px;
}

/* 主体容器：撑开Header和Footer之间的高度 */
.main-content {
  flex: 1; /* 核心：占据除Header/Footer外的所有高度 */
  width: 100%;
}

/* Footer 改为跟随页面底部（关键修改） */
Footer {
  width: 100%;
  background: #fff;
  /* height: 60px; */
  /* 核心：去掉fixed定位，改用margin-top:auto贴底 */
  margin-top: auto; 
  /* 可选：加个上边框，区分内容和Footer */
  border-top: 1px solid #eee;
}
</style>